export default __webpack_public_path__ + "static/media/IMG-20241005-WA0012.e599c571.jpg";